import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomeEvaluationRangeVM } from '../../../CustomEval/custom-eval.model';
import { InterpretationService } from '../../interpretation.service';
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { SystemModel, QuoteOverviewModel, TRACKForcastVM, InspectionForecastPreferenceModel } from '../../models/interpretation.model';
import { NotificationsService } from 'angular2-notifications';
import { ForecastResetComponent } from '../forecast-reset/forecast-reset.component';
import moment from "moment";
import { MatDialog } from '@angular/material/dialog';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { SetupEquipmentService } from '../../../../../app/modules/setup-equipment/setup-equipment.service';
import { PmServiceTypes, PmServiceTypesVM } from '../../../../../app/modules/setup-equipment/setup-equipment.model';

@Component({
  selector: 'forecast-undercariage',
  templateUrl: './forecast-undercariage.component.html',
  styleUrls: ['./forecast-undercariage.component.scss'],
})
export class ForecastUndercariageComponent {
  @Input() inspectionId: number = -1;
  @Input() systemId: number = 1;
  @Input() Family_: string
  @Input() FamilyImage_Frame: string
  @Input() FamilyImage_Chain: string
  @Input() equipmentID: number;
  @Input() ShowHideCRoller: boolean;
  quotes: QuoteOverviewModel[] = [];
  system: SystemModel = new SystemModel();
  @Input() EvalautionRange: CustomeEvaluationRangeVM;
  @Input() unitNo: string;
  PmServiceTypesVM: PmServiceTypesVM;
  PmServiceTypes: PmServiceTypes[] = [];
  loadingSystems = true;
  side = 'Left';
  type = 'Chain';
  isInspector = false;
  isInterpreter = false;
  _inspectionId: number = -1;
  overallEval = 'U';
  overallEvalLoading = true;
  removeFlagPopup = false;
  userLanguage: string = "english";
  flag_comment: string = "";
  flag_on: boolean = false;
  selected_inspection_detail_auto: number;
  selected_track_unit_auto: number;
  glb_LocalIncpectionid: any;
  isEnableMaxRange: boolean;
  forecastDataVM: TRACKForcastVM;
  PM_1_Date: Date;
  //Method: string = "";
  reqPattern = 'dd/MM/yyyy';
  NextPMSMU: number = 0;
  NextPmDistance: number = 0;
  SecondPMSMU: number = 0;
  SecondDistance: number = 0;
  FloatingSMU: number;
  FloatingDistance: number = 0;
  FloatingSMU2: number = 0;
  FloatingDistance2: number = 0;
  PmNextDate: Date;
  Pm2NextDate: Date;
  FloatingDate: Date;
  FloatingDate2: Date;
  saving: boolean;
  dayDiff: number = 0;
  dayDiff1: number = 0;
  dayDiff2: number = 0;
  dayDiff3: number = 0;
  lastSMU: number = 0;
  lastInspectionDate: Date;
  diffBetweenLastandPreviousInpectionUsgHours1: number = 0;
  diffBetweenLastandPreviousInpectionUsgHours2: number = 0;
  diffBetweenLastandPreviousInpectionUsgHours3: number = 0;
  diffBetweenLastandPreviousInpectionUsgHours4: number = 0;
  diffBetweenLastandPreviousInpectionDistance1: number = 0;
  diffBetweenLastandPreviousInpectionDistance2: number = 0;
  diffBetweenLastandPreviousInpectionDistance3: number = 0;
  diffBetweenLastandPreviousInpectionDistance4: number = 0;
  _minDateNextPm: Date = new Date();
  _minDateSecoundPm: Date = new Date();
  _minDateFlaotingDate1: Date = new Date();
  _minDateFlaotingDate2: Date = new Date();
  hourChecked: boolean = true;
  calculatedUsaghourChecked: boolean = true;
  conditionalCalculatedValue: boolean = true;
  systemIds: number[] = [];
  refreshComponents: boolean = false;
  userUOD: string = "";

  constructor(private _route: ActivatedRoute,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private dialog: MatDialog,
    private _pref: PreferencesService,
    private _planerService: SetupEquipmentService,
  ) {


  }
  ForecastData = new FormGroup({
    Daily_Usage_Hours: new FormControl(null,
    [
      Validators.min(0),
      Validators.max(24)
    ]),
    Daily_Usage_Distance: new FormControl(),
    Forecast_Method: new FormControl('1'),
    DistanceRatio: new FormControl(),
    PM_1_Date: new FormControl(Validators.pattern(this.reqPattern)),
    PM_2_Date: new FormControl(Validators.pattern(this.reqPattern)),
    Floating_Date: new FormControl(Validators.pattern(this.reqPattern)),
    Floating_Date2: new FormControl(Validators.pattern(this.reqPattern)),
    Daily_Usage_Calculation_Method: new FormControl('1'), // Default value as '1'
    show120Worn: new FormControl(),
    show100Worn: new FormControl(),
    showLastFourth: new FormControl(),
    PmNextServiceType: new FormControl(),
    PmSecondServiceType: new FormControl(),
    FloatingDate1ServiceType: new FormControl(),
    FloatingDate2ServiceType: new FormControl(),
    SafteyFactor: new FormControl(),
    MidpointPercentage: new FormControl(),
    WeatherType: new FormControl(),
    PresetAvg: new FormControl(),
  })

  show100Worn: boolean = false;
  show120Worn: boolean = false;
  showLastFourth: boolean = false;
  selectedValue = '1'
  ngOnInit() {
    this.inspectionId = this._route.snapshot.params.id;
    this.GetForecastPreference();
    this.loadSystemIds();
    this.getUserUOD();
    this.CheckForUnitNumber();
    this.GetPmServiceData();
  }
  loadSystemIds() {
    this._interp.getSystemIds(this.inspectionId).subscribe(systems => {
      this.systemIds = systems;
      console.log(this.systemIds)
    });
  }
  validateHours(event: any): void {
  const value = Number(event?.target?.value);
  if (value > 24) {
    event.target.value = 24;
    this.ForecastData?.get('Daily_Usage_Hours')?.setValue(
      24,
      { emitEvent: false }
    );
  }
}
  getDailyUsagehoursAndDailyDistance() {
    this._interp.getDailyUsageHoursAndDistance(this.inspectionId).subscribe(result => {
      this.forecastDataVM = result;
      this.ForecastData.controls['DistanceRatio'].setValue(this.forecastDataVM.DistanceRatio);
      if (this.forecastDataVM.ForecastMethod != "" && this.forecastDataVM.ForecastMethod != null) {
        if (this.forecastDataVM.ForecastMethod == "Hours") {
          this.hourChecked = true;
          this.ForecastData.controls['Forecast_Method'] = new FormControl('1')

        } else {
          this.hourChecked = false;
          this.ForecastData.controls['Forecast_Method'] = new FormControl('2')
        }
      }
      else {
        this.hourChecked = true;
      }
      if (this.forecastDataVM.DailyUsageCalculationMethod != "" && this.forecastDataVM.DailyUsageCalculationMethod != null) {
        if (this.forecastDataVM.DailyUsageCalculationMethod == "calculated") {
          this.calculatedUsaghourChecked = true;
          this.conditionalCalculatedValue = true;
          this.ForecastData.controls['Daily_Usage_Calculation_Method'] = new FormControl('1')
        } else {
          this.calculatedUsaghourChecked = false;
          this.conditionalCalculatedValue = false;
          this.ForecastData.controls['Daily_Usage_Calculation_Method'] = new FormControl('2')
        }
      } else {
        this.calculatedUsaghourChecked = true;
        this.conditionalCalculatedValue = true;
      }
      this.selectedValue = this.forecastDataVM.ForecastCalculationMethod.toString();
      if (this.forecastDataVM.ForecastCalculationMethod == 1) {
        this.BoolRadioCheck = true
        this.ForecastData.controls['PresetAvg'] = new FormControl('1')
      } else {
        this.BoolRadioCheck = false
        this.ForecastData.controls['PresetAvg'] = new FormControl('2')
      }
      this.NextPmDistance = this.forecastDataVM.PmNextDateServiceDOE;
      this.NextPMSMU = this.forecastDataVM.PmNextDateServiceSMU;
      this.SecondDistance = this.forecastDataVM.SecondPmNextDateServiceDOE;
      this.SecondPMSMU = this.forecastDataVM.SecondPmNextDateServiceSMU;
      this.FloatingDistance = this.forecastDataVM.FloatingDOE;
      this.FloatingSMU = this.forecastDataVM.FloatingSMU;
      this.FloatingDistance2 = this.forecastDataVM.FloatingDOE2;
      this.FloatingSMU2 = this.forecastDataVM.FloatingSMU2;
      this.ForecastData.controls['Daily_Usage_Hours'].setValue(this.forecastDataVM.DailyUsageHours);
      this.ForecastData.controls['Daily_Usage_Distance'].setValue(this.convertDistanceKmToMi(this.forecastDataVM.DailyUageDistance));
      this.ForecastData.controls['SafteyFactor'].setValue(this.forecastDataVM.SafetyFactor);
       this.ForecastData.controls['MidpointPercentage'].setValue(this.forecastDataVM.MidpointPercentage);
      this.ForecastData.controls['WeatherType'].setValue(this.forecastDataVM.WeatherTypeId);
      this.ForecastData.controls['PM_1_Date'].setValue(this.forecastDataVM.PmNextDateService);
      this.ForecastData.controls['PM_2_Date'].setValue(this.forecastDataVM.SecondPmNextDateService);
      this.ForecastData.controls['Floating_Date'].setValue(this.forecastDataVM.FloatingDate);
      this.ForecastData.controls['Floating_Date2'].setValue(this.forecastDataVM.FloatingDate2);
      this.ForecastData.controls['show100Worn'].setValue(this.forecastDataVM.Show100Worn);
      this.ForecastData.controls['show120Worn'].setValue(this.forecastDataVM.Show120Worn);
      this.ForecastData.controls['showLastFourth'].setValue(this.forecastDataVM.ShowLastFourth);
      this.ForecastData.controls['PmNextServiceType'].setValue(this.forecastDataVM.PmNextServiceType);
      this.ForecastData.controls['PmSecondServiceType'].setValue(this.forecastDataVM.PmSecondServiceType);
      this.ForecastData.controls['FloatingDate1ServiceType'].setValue(this.forecastDataVM.FloatingDate1ServiceType);
      this.ForecastData.controls['FloatingDate2ServiceType'].setValue(this.forecastDataVM.FloatingDate2ServiceType);
      if (this.forecastDataVM.PmNextDateService != null) {
        this.onNextPmDateChange(1)
      }
      if (this.forecastDataVM.SecondPmNextDateService != null) {
        this.onNextPmDateChange(2)

      }
      if (this.forecastDataVM.FloatingDate != null) {
        this.onNextPmDateChange(3)

      }
      if (this.forecastDataVM.FloatingDate2 != null) {
        this.onNextPmDateChange(4)

      }
    });
  }
  InspectionForecastPreferenceModel: InspectionForecastPreferenceModel = new InspectionForecastPreferenceModel();
  GetActionType: number;
  GetForecastPreference() {
    this._interp.GetForecastPreference(this.inspectionId).subscribe(result => {
      this.InspectionForecastPreferenceModel = result;
      this.GetActionType = this.InspectionForecastPreferenceModel.ActionTypeId;
      this.getDailyUsagehoursAndDailyDistance()
    });
  }
  onNextPmDateChange(value: number) {
    if (this.GetActionType == 41) {
      if (value == 1) {
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          this._minDateSecoundPm = this.ForecastData.controls['PM_1_Date'].value;
          const start = new Date(this.InspectionForecastPreferenceModel.EventDate).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));
          if (this.calculatedUsaghourChecked) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.InspectionForecastPreferenceModel.Smu);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.Smu);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }
        }
      } else if (value == 2) {
        this.conditionalCalculatedValue = false;
        this._minDateFlaotingDate1 = this.ForecastData.controls['PM_2_Date'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {
          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff1 - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance);
          }
        }

      } else if (value == 3) {
        this._minDateFlaotingDate2 = this.ForecastData.controls['Floating_Date'].value;
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {

            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff2 - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance);
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
        }
      } else {
        if (this.ForecastData.controls['Floating_Date'].value != null && this.ForecastData.controls['Floating_Date2'].value != null) {
          const start = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date2'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date2'].value != null) {
            this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff3 = this.dayDiff3 - (Math.floor(this.dayDiff3 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance);
          }
          else {
            this.FloatingSMU2 = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance)
          }
        }
      }
    } else {
      if (value == 1) {
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          this._minDateSecoundPm = this.ForecastData.controls['PM_1_Date'].value;
          const start = new Date(this.forecastDataVM.LastInpectionDateOnly).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));
          if (this.calculatedUsaghourChecked) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }
        }
      } else if (value == 2) {
        this.conditionalCalculatedValue = false;
        this._minDateFlaotingDate1 = this.ForecastData.controls['PM_2_Date'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {
          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff1 - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance);
          }
        }
      } else if (value == 3) {
        this._minDateFlaotingDate2 = this.ForecastData.controls['Floating_Date'].value;
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff2 - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance);
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
        }
      } else {
        if (this.ForecastData.controls['Floating_Date'].value != null && this.ForecastData.controls['Floating_Date2'].value != null) {
          const start = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date2'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date2'].value != null) {
            this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff3 = this.dayDiff3 - (Math.floor(this.dayDiff3 / 7) * (7 - this.forecastDataVM.ActiveDays));
            //this.dayDiff3 = this.dayDiff3 -(Math.floor(this.dayDiff3/7)* (7-this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance);
          }
          else {
            this.FloatingSMU2 = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance)
          }
        }
      }
    }
  }

  BoolRadioCheck: boolean = true;
  onRadioChange(value: number) {
    if (value == 1) {
      this.calculatedUsaghourChecked = true;
    } else {
      this.calculatedUsaghourChecked = false;
    }
    if (this.GetActionType == 41) {
      if (this.forecastDataVM != null) {
        var _Method = this.ForecastData.controls['Daily_Usage_Calculation_Method'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          const start = new Date(this.InspectionForecastPreferenceModel.EventDate).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));
          if (_Method == 1) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.Smu);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }
        }
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {

          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
        }
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
        }
      }
    }
    else {
      if (this.forecastDataVM != null) {
        var _Method = this.ForecastData.controls['Daily_Usage_Calculation_Method'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          const start = new Date(this.forecastDataVM.LastInpectionDateOnly).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));
          if (_Method == 1) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }
        }
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {

          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
        }
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
        }
      }
    }
  }

  onforecastMethodCalution(Value: number) {
    if (Value == 1) {
      this.selectedValue = '1';
      this.BoolRadioCheck = true
    } else {
      this.selectedValue = '2';
      this.BoolRadioCheck = false
    }
  }
  getForecasFuturetInspectionDetails(forecastDetails: any) {
    //debugger;
    if (this.GetActionType == 41) {
      this.lastSMU = this.InspectionForecastPreferenceModel.Smu
      forecastDetails.lastInspectionDate = this.InspectionForecastPreferenceModel.EventDate
    } else {
      this.lastSMU = forecastDetails.LastinspectionSMU;
    }
    if (forecastDetails.LastInpectionDateOnly && forecastDetails.PmNextDateService) {

      this._minDateSecoundPm = forecastDetails.PmNextDateService;
      this._minDateFlaotingDate1 = forecastDetails.SecondPmNextDateService;
      this._minDateFlaotingDate2 = forecastDetails.FloatingDate;
      if (forecastDetails.PmNextDateService != null) {
        let startdate = forecastDetails.PmNextDateService;
        let endDate = forecastDetails.SecondPmNextDateService;
        const start = new Date(startdate).getTime();
        const end = new Date(endDate).getTime();
        const diff = end - start;
        if (endDate != null) {
          this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
        }
        const start1 = new Date(forecastDetails.SecondPmNextDateService).getTime();
        const end1 = new Date(forecastDetails.FloatingDate).getTime();
        const diff1 = end1 - start1;
        if (forecastDetails.FloatingDate != null) {
          this.dayDiff2 = Math.floor(diff1 / (1000 * 60 * 60 * 24));
        }
        const start3 = new Date(forecastDetails.FloatingDate).getTime();
        const end3 = new Date(forecastDetails.FloatingDate2).getTime();
        const diff3 = end3 - start3;
        if (forecastDetails.FloatingDate2 != null) {
          this.dayDiff3 = Math.floor(diff3 / (1000 * 60 * 60 * 24));
        }
        const start2 = new Date(this.forecastDataVM.LastInpectionDateOnly).getTime();
        const end2 = new Date(forecastDetails.PmNextDateService).getTime();
        const diff2 = end2 - start2;
        this.dayDiff = Math.floor(diff2 / (1000 * 60 * 60 * 24));
        this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - forecastDetails.LastinspectionSMU);
        this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
      }
    }
    if (forecastDetails.SecondPmNextDateService != null) {
      if (forecastDetails.PmNextDateService && forecastDetails.SecondPmNextDateService) {
        this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
        this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
      }
    }
    if (forecastDetails.FloatingDate != null) {
      if (forecastDetails.SecondPmNextDateService && forecastDetails.FloatingDate) {
        this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
        this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
      }
    }
    if (forecastDetails.FloatingDate2 != null) {
      if (forecastDetails.FloatingDate && forecastDetails.FloatingDate2) {
        this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
        this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance)
      }
    }
  }

  onSubmit() {
    this.refreshComponents = false;
    var foreCastData = new TRACKForcastVM();
    foreCastData.InspectionId = this.inspectionId;
    foreCastData.DailyUsageHours = this.ForecastData.controls['Daily_Usage_Hours'].value;
    foreCastData.DailyUageDistance = this.convertDistanceMiToKm(this.ForecastData.controls['Daily_Usage_Distance'].value);
    foreCastData.ForecastMethod = this.hourChecked ? "Hours" : "Distance";// this.ForecastData.controls['Forecast_Method'].value == "1" ? "Hours" : "Distance";
    foreCastData.PmNextDateService = this.ForecastData.controls['PM_1_Date'].value != null ? new Date(this.ForecastData.controls['PM_1_Date'].value) : null;
    foreCastData.PmNextDateServiceString = this.ForecastData.controls['PM_1_Date'].value != null ? moment(this.ForecastData.controls['PM_1_Date'].value).format('MM/DD/YYYY') : null;
    foreCastData.SecondPmNextDateService = this.ForecastData.controls['PM_2_Date'].value != null ? new Date(this.ForecastData.controls['PM_2_Date'].value) : null;
    foreCastData.SecondPmNextDateServiceString = this.ForecastData.controls['PM_2_Date'].value != null ? moment(this.ForecastData.controls['PM_2_Date'].value).format('MM/DD/YYYY') : null;
    foreCastData.FloatingDate = this.ForecastData.controls['Floating_Date'].value != null ? new Date(this.ForecastData.controls['Floating_Date'].value) : null;
    foreCastData.FloatingDateString = this.ForecastData.controls['Floating_Date'].value != null ? moment(this.ForecastData.controls['Floating_Date'].value).format('MM/DD/YYYY') : null;
    foreCastData.FloatingDate2 = this.ForecastData.controls['Floating_Date2'].value != null ? new Date(this.ForecastData.controls['Floating_Date2'].value) : null;
    foreCastData.FloatingDateString2 = this.ForecastData.controls['Floating_Date2'].value != null ? moment(this.ForecastData.controls['Floating_Date2'].value).format('MM/DD/YYYY') : null;
    foreCastData.PmNextDateServiceSMU = +this.NextPMSMU;
    foreCastData.PmNextDateServiceDOE = this.convertDistanceMiToKm(+this.NextPmDistance);
    foreCastData.SecondPmNextDateServiceSMU = +this.SecondPMSMU;
    foreCastData.SecondPmNextDateServiceDOE = this.convertDistanceMiToKm(+this.SecondDistance);
    foreCastData.FloatingSMU = +this.FloatingSMU;
    foreCastData.FloatingDOE = this.convertDistanceMiToKm(+this.FloatingDistance);
    foreCastData.FloatingSMU2 = +this.FloatingSMU2;
    foreCastData.FloatingDOE2 = this.convertDistanceMiToKm(+this.FloatingDistance2);
    foreCastData.DailyUsageCalculationMethod = this.calculatedUsaghourChecked == true ? "calculated" : "manually";
    foreCastData.Show100Worn = this.ForecastData.controls['show100Worn'].value;
    foreCastData.Show120Worn = this.ForecastData.controls['show120Worn'].value;
    foreCastData.ShowLastFourth = this.ForecastData.controls['showLastFourth'].value;
    foreCastData.PmNextServiceType = this.ForecastData.controls['PmNextServiceType'].value;
    foreCastData.PmSecondServiceType = this.ForecastData.controls['PmSecondServiceType'].value;
    foreCastData.FloatingDate1ServiceType = this.ForecastData.controls['FloatingDate1ServiceType'].value;
    foreCastData.FloatingDate2ServiceType = this.ForecastData.controls['FloatingDate2ServiceType'].value;
    foreCastData.SafetyFactor = this.ForecastData.controls['SafteyFactor'].value;
    foreCastData.MidpointPercentage = this.ForecastData.controls['MidpointPercentage'].value;
    foreCastData.WeatherTypeId = this.ForecastData.controls['WeatherType'].value;
    foreCastData.ForecastCalculationMethod = Number(this.selectedValue);
    foreCastData.DistanceRatio = this.ForecastData.controls['DistanceRatio'].value;
    
    this._interp.SaveForeCastData(foreCastData).subscribe(
      res => {
        if (res == 1) {
          this.refreshComponents = false;
          this._notify.success('Success', 'Record saved successfully');
          this.getDailyUsagehoursAndDailyDistance();
          this.refreshComponents = true;
          this.loadSystemIds();
        }
      },
      () => {
        this._notify.error('Error saving data', 'Failed to save the record');
      }
    );
  }
  ResetFields() {
    this.refreshComponents = false;
    this.openDialog()
  }

  GetPmServiceData() {
    this._planerService.GetPmServiceTypes().subscribe(result => {
      if (result != null) {
        this.PmServiceTypes = result.Data;
        console
        this.PmServiceTypesVM = result;
      }
    });
  }

  OnUsageRadioValChange(value: number) {
    if (value == 1) {
      this.hourChecked = true;
    } else {
      this.hourChecked = false;
    }
  }

  GetExactDate(date): Date {
    let momentToDate = moment(date).toDate();
    date = new Date(Date.UTC(momentToDate.getFullYear(), momentToDate.getMonth(), momentToDate.getDate(), momentToDate.getHours(), momentToDate.getMinutes(), momentToDate.getSeconds()));
    return date;
  }

  openDialog() {
    let confirmationModalRef = this.dialog.open(ForecastResetComponent, {
      width: '480px'

    });
    confirmationModalRef.afterClosed().subscribe(r => {
      if ((r.data != null) && (r.data.goAhead)) {
        this._interp.ForecastTrackReset(this.inspectionId).subscribe(res => {
          if (res == 1) {
            this.refreshComponents = false;
            //console.log("Afterfalse:",this.refreshComponents);
            this._notify.success('Success', 'Record reset successfully');
            this.getDailyUsagehoursAndDailyDistance();
            this.diffBetweenLastandPreviousInpectionUsgHours1 = 0;
            this.diffBetweenLastandPreviousInpectionUsgHours2 = 0;
            this.diffBetweenLastandPreviousInpectionDistance2 = 0;
            this.diffBetweenLastandPreviousInpectionDistance1 = 0;
            this.diffBetweenLastandPreviousInpectionUsgHours3 = 0;
            this.diffBetweenLastandPreviousInpectionDistance3 = 0;
            this.dayDiff = this.dayDiff1 = this.dayDiff2 = 0;
            this.ForecastData.reset();
            (<HTMLInputElement>document.getElementById("usage")).checked = true;
            (<HTMLInputElement>document.getElementById("calculatedUsageHrs")).checked = true;
            this.hourChecked = true;
            this.calculatedUsaghourChecked = true;
            this.refreshComponents = true;
            this.loadSystemIds();
          }
        },
          () => {
            this._notify.error('Error saving data', 'Failed to reset the record');
          })
      }
    });
  }
  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }
  //to save values in KM when user preferance is in miles
  convertDistanceMiToKm(val: number): number {
    return this.userUOD === 'km' ? val : Math.round(val * 1.60934);
  }

  ModelMachineLevel: boolean;
  CheckForUnitNumber() {
    this._interp.CheckForUnitNumber(this.unitNo).subscribe(result => {
      if (result == true) {
        this.ModelMachineLevel = true
      } else {
        this.ModelMachineLevel = false
      }
    });
  }

  NavigateTo() {
    window.open(`/forecast-configuration`, '_blank');
  }
 limitOneDecimal(event: any) {
  let value = event.target.value;

  const regex = /^\d+(\.\d{0,1})?/;

  const match = value.match(regex);
  if (match) {
    event.target.value = match[0];
    this.ForecastData.controls['DistanceRatio'].setValue(match[0]);
  } else {
    event.target.value = '';
    this.ForecastData.controls['DistanceRatio'].setValue(0);
  }
}

}